module.exports = __webpack_public_path__ + "img/coach-income-icon.7ab3a0f9.png";